import React, { useState, useEffect, useCallback } from 'react';
import _, { max } from 'lodash';
import { Collapse } from 'react-collapse';

function BallSpeed(props) {
    const { selected } = props;
    const [isOpened, setIsOpened] = useState(false);
    const minData = [null, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 175];
    let [maxData, setMaxData] = useState([0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 175, null]);
    const [speed, setSpeed] = useState({
        min: selected.min ? selected.min : null,
        max: selected.max ? selected.max : null,
    });

    useEffect(() => {
        props.onChange(speed);
        if ( (speed.min != null && speed.max == null) ){
            setSpeed.max = minData[minData.length-1]
            speed.max = minData[minData.length-1]
        }
        else if( (speed.min == null && speed.max != null) ){
            setSpeed.min = minData[1]
            speed.min = minData[1]
        }
        else if(speed.min > speed.max){
            setSpeed.max = minData[minData.length-1]
            speed.max = minData[minData.length-1]
        }
    }, [speed]);

    const handleMinChange = useCallback((e) => {
        const value = e.target.value === 'null' ? null : Number(e.target.value);
        const newMaxData = minData.filter(item => item >= value);
        setMaxData(newMaxData);
        setSpeed((state) => ({ ...state, min: value }));
    }, [maxData]);

    const handleMaxChange = useCallback((e) => {
        const value = e.target.value === 'null' ? null : Number(e.target.value);
        setSpeed((state) => ({ ...state, max: value }));
    }, []);

    return (
        <div className="group-filter-item">
            <div className={'open-collapse'}>
                <div className="toggle-collapse" onClick={() => setIsOpened(!isOpened)}>
                    <h4>球速</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{ transform: isOpened && 'rotate(180deg)' }} />
                </div>
                <Collapse isOpened={isOpened}>
                    <div style={{ justifyContent: 'start', display: 'flex', padding: '10px' }}>
                        <select className="form-control select-custome" value={speed.min ?? ''} onChange={handleMinChange}>
                            {minData.map((item, index) => (
                                <option key={index} value={item === null ? 'null' : item}>
                                    {item === null ? '球速選択なし' : `${item}km/h`}
                                </option>
                            ))}
                        </select>
                        <span style={{ marginTop: 0, marginLeft: 5, marginRight: 5, fontSize: 30 }}> ~ </span>
                        <select className="form-control select-custome" value={speed.max ?? ''} onChange={handleMaxChange}>
                            {_.reverse([...maxData]).map((item, index) => (
                                <option key={index} value={item === null ? 'null' : item}>
                                    {item === null ? '球速選択なし' : `${item}km/h`}
                                </option>
                            ))}
                        </select>
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse'>
                    <h4>球速</h4>
                </div>
                <div style={{
                    justifyContent: 'start',
                    display: 'flex',
                    padding: '10px',
                }}>
                    <select className="form-control select-custome" value={speed.min ?? ''} onChange={handleMinChange}>
                        {minData.map((item, index) => (
                            <option key={index} value={item === null ? 'null' : item}>
                                {item === null ? '球速選択なし' : `${item}km/h`}
                            </option>
                        ))}
                    </select>
                    <span style={{ marginTop: 0, marginLeft: 5, marginRight: 5, fontSize: 30 }}> ~ </span>
                    <select className="form-control select-custome" value={speed.max ?? ''} onChange={handleMaxChange}>
                        {_.reverse([...maxData]).map((item, index) => (
                            <option key={index} value={item === null ? 'null' : item}>
                                {item === null ? '球速選択なし' : `${item}km/h`}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    )
}
export default BallSpeed;
